export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ru": {
        "partCount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Частей:"])},
        "taskCount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Задач:"])},
        "publisher": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["vr chemistry lab"])}
      },
      "en": {
        "partCount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Parts:"])},
        "taskCount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tasks:"])},
        "publisher": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["vics studio"])}
      }
    }
  })
}
